module.exports = __webpack_public_path__ + "img/Feature.327b35c0.png";